var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCanvasComponent',{ref:"can",class:_vm.anim,on:{"animationend":_vm.removeAnim}})}
var staticRenderFns = []

export { render, staticRenderFns }